import { render } from "./Lottie.vue?vue&type=template&id=17f0c894&scoped=true"
import script from "./Lottie.vue?vue&type=script&lang=js"
export * from "./Lottie.vue?vue&type=script&lang=js"

import "./Lottie.vue?vue&type=style&index=0&id=17f0c894&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17f0c894"

export default script